import {
  type BuildDetailsFieldsParams,
  checkboxField,
  field,
  selectField,
  typedField,
  withLayout,
} from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildKeyCommercialsFields({ opportunity }: BuildDetailsFieldsParams): Array<DetailField> {
  const keyCommercial = opportunity?.key_commercial;

  return [
    selectField(
      'Deal Tier',
      keyCommercial?.deal_tier__c,
      ['Luxury Escapes - Tier 1', 'Luxury Escapes - Tier 2', 'Luxury Escapes - Tier 3'],
      undefined,
      {
        columns: 3,
        group: 'Deal Tier',
      },
    ),
    withLayout(field('Deal Tier Definitions', undefined), { columns: 3, group: 'Deal Tier' }),
    selectField(
      'Connection/Redemption Type',
      undefined,
      ['Calendar Booking', 'Instant Confirmation', 'On Request'],
      'The basic redemption options for most deals',
      { columns: 3, group: 'Deal Tier' },
    ),
    typedField('Sales Person Margin Forecast (AUD)', undefined, 'number', undefined, {
      columns: 3,
      group: 'Financial Forecasts',
    }),
    typedField('Sales Person Gross Sales Forecast (AUD)', undefined, 'number', undefined, {
      columns: 3,
      group: 'Financial Forecasts',
    }),
    typedField('Sales Person Margin % Forecast', undefined, 'number', undefined, {
      columns: 3,
      group: 'Financial Forecasts',
    }),
    typedField('Weighting', undefined, 'number', undefined, { columns: 3, group: 'Financial Forecasts' }),
    typedField('TripAdvisor Link', keyCommercial?.tripadvisor_link__c, 'url', undefined, {
      columns: 3,
      group: 'Financial Forecasts',
    }),
    withLayout(field('RM Notes', undefined, 'Revenue management notes for approvers.', true), {
      columns: 1,
      group: 'Financial Forecasts',
    }),
    selectField(
      'Performance Override (PO)',
      keyCommercial?.accelerated_margin__c,
      ['True', 'False'],
      'Performance override indicator.',
      {
        columns: 3,
        group: 'Performance Override',
      },
    ),
    typedField(
      'PO %',
      undefined,
      'number',
      'Please advise the override percentage % this deal is expected to achieve.',
      {
        columns: 3,
        group: 'Performance Override',
      },
    ),
    withLayout(
      field(
        'Brand NOT Running',
        keyCommercial?.brand_not_running__c,
        'This field is used to communicate which Brands this deal cannot run in. Please use the field named Reason for Brand Exclusion to justify why this brand is being excluded.',
      ),
      { columns: 2, group: 'Brand & Country Restrictions' },
    ),
    withLayout(
      field(
        'Reason for Brand Exclusion',
        keyCommercial?.reason_4_brand_exclusion__c,
        'This field must be populated if this deal will not be running in any specific Brands.',
        true,
      ),
      { columns: 2, group: 'Brand & Country Restrictions' },
    ),
    withLayout(
      field(
        'Countries NOT to Run',
        keyCommercial?.countries_not_to_run__c,
        'This field is used to communicate which Countries this deal cannot run in. Please use the field named Reason for Country Exclusion to justify why this Country is being excluded.',
      ),
      { columns: 2, group: 'Brand & Country Restrictions' },
    ),
    withLayout(
      field(
        'Reason for Country Exclusion',
        keyCommercial?.reason_4_country_exclusion__c,
        'Required if Countries NOT to Run is populated.',
        true,
      ),
      { columns: 2, group: 'Brand & Country Restrictions' },
    ),
    checkboxField('Override Krisflyer', undefined, undefined, { columns: 3, inline: true }),
    checkboxField('KrisFlyer', true, undefined, { columns: 3, inline: true }),
    checkboxField('Refunds Not Permitted', keyCommercial?.refunds_not_permitted__c, undefined, {
      columns: 3,
      inline: true,
    }),
    withLayout(
      field(
        'Notes For Approval',
        undefined,
        'Use this box to provide approvers and the Media Planning dept. with anything that you think would be helpful when considering this deal opportunity.',
        true,
      ),
      { columns: 1 },
    ),
    withLayout(field('Addendum out. Confirming book by period too', undefined), { columns: 1 }),
  ];
}
